import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#c9a24d" }, // gold accent
    secondary: { main: "#0f172a" }, // deep navy
    background: {
      default: "#f6f7fb",
      paper: "#ffffff",
    },
    text: {
      primary: "#0b1220",
      secondary: "#526070",
    },
  },
  typography: {
    fontFamily: ["Inter", "system-ui", "Arial", "sans-serif"].join(","),
  },
  shape: { borderRadius: 16 },
});

export default theme;
